<template>
    <div>
        <!-- <p style="font-size: 0.4rem">
          {{ groupInfo.name }}
        </p>
        <p style="margin-top: 0.2rem; color: grey; font-size: 0.26rem">
            群主：{{ groupInfo.boss }} | 创建时间：{{ groupInfo.create_time }}
        </p> -->
        <!-- <p style="margin-top: 0.2rem; color: grey; font-size: 0.26rem">
            <el-collapse v-if="groupInfo.notice">
                <el-collapse-item title="群公告">
                    <p style="white-space: pre-wrap">{{ groupInfo.notice }}</p>
                </el-collapse-item>
            </el-collapse>
            <span v-else>群公告：未设置</span>
        </p> -->
        <el-table :data="groupInfo" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak>
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline>
                        <table>
                            <thead style="
                            color: #333;
                            font-weight: bold;
                            font-size: medium
                        ">
                                <tr>
                                    <th>序号</th>
                                    <th>群成员</th>
                                    <th>群昵称</th>
                                    <th>进群时间</th>
                                    <th>进群方式</th>
                                </tr>
                            </thead>
                            <tr v-for="item, index in props.row.members" :key="item.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.name }}
                                    <span style="color: #2db34a" v-if="item.member_type === 2">
                                        @微信</span>
                                </td>
                                <td>
                                    <el-tooltip :content="item.group_nickname
                                        ? item.group_nickname
                                        : item.name
                                        " placement="top" :open-delay="500">
                                        <span>{{
                                            item.group_nickname
                                            ? item.group_nickname
                                            : item.name
                                        }}</span>
                                    </el-tooltip>
                                </td>
                                <td>{{ item.join_time }}</td>
                                <td>
                                    <el-tooltip :content="getJoinType(item)" placement="top" :open-delay="500">
                                        <span>{{ getJoinType(item) }}</span>
                                    </el-tooltip>
                                </td>
                            </tr>
                        </table>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column label="群名称">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.name" placement="top" :open-delay="500">
                        <span class="hide-style">{{ scope.row.name }} </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="群公告">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.notice ? scope.row.notice : '未设置'" placement="top" :open-delay="500">
                        <span class="hide-style">{{ scope.row.notice ? scope.row.notice : '未设置' }} </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="群主">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.boss" placement="top" :open-delay="500">
                        <span class="hide-style">{{ scope.row.boss }} </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="create_time">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click.native="execBind(scope.row.chat_id)" type="primary" size="mini">
                        绑定
                    </el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column label="群成员">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.members.name" placement="top" :open-delay="500">
                        <span class="hide-style">{{ scope.row.members.name
                        }}<span style="color: #2db34a" v-if="scope.row.members.member_type === 2">
                                @微信</span></span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="群昵称">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.group_nickname
                            ? scope.row.group_nickname
                            : scope.row.name
                        " placement="top" :open-delay="500">
                        <span class="hide-style">{{
                            scope.row.group_nickname
                            ? scope.row.group_nickname
                            : scope.row.name
                        }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="进群时间">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.join_time" placement="top" :open-delay="500">
                        <span class="hide-style">{{ scope.row.join_time }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="进群方式">
                <template slot-scope="scope">
                    <el-tooltip :content="getJoinType(scope.row)" placement="top" :open-delay="500">
                        <span class="hide-style">{{ getJoinType(scope.row) }}</span>
                    </el-tooltip>
                </template>
            </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'GroupInfoOnly',
    props: {
        chat_id: {
            type: Array
        },
    },
    data() {
        return {
            groupInfo: []
        }
    },
    watch: {
        // chat_id(n) {
        //     this.groupInfo = {}
        //     this.$emit('doBind', false)
        //     if (n.length > 0) {
        //         this.getGroupInfo(n)
        //     }
        // },
        chat_id: {
            handler(n) {
                this.groupInfo = []
                this.$emit('doBind', false)
                if (n.length > 0) {
                    this.getGroupInfo(n)
                }
            },
            deep: true
        }
    },
    methods: {
        getGroupInfo(chat_id) {
            // this.$axios.get('api/ysy_order_bind_we_chat_get_chat_group?chat_id=' + chat_id).then(({ data }) => {
            this.$axios.post('api/ysy_order_bind_we_chat_get_chat_group', {
                params: {
                    chat_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    console.log(data.data)
                    this.groupInfo = data.data
                    this.$emit('doBind', true)
                }
            }).catch()
        },
        getJoinType(row) {
            let str = ''
            if (row.join_scene < 3) {
                str = '由 ' + (row.employee ? row.employee.name : '成员') + ' 邀请入群'
            } else {
                str = '通过扫描群二维码入群'
            }

            return str
        },
        execBind(chat_id) {
            this.$emit('doRealBind', { chat_id })
        }
    },
    mounted() {
        //
    }
}
</script>

<style scoped>
thead>tr>th {
    background: #ecf4ff;
}

table {
    border: 1px solid #ccc
}
</style>


// WEBPACK FOOTER //
// src/common/GroupInfoOnly.vue